import { FieldArray, FormikProps } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
// import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
// import useCourse from "src/hooks/useCourse";
// import useCourseType from "src/hooks/useCourseType";
// import useFaculty from "src/hooks/useFaculty";
// import useLevels from "src/hooks/useLevels";
// import useModes from "src/hooks/useMode";
import usePaymentModes from "src/hooks/usePaymentModes";
// import useSubjects from "src/hooks/useSubject";
import { OfflineOrderFormValues } from "src/models/OfflineOrder.model";
// import { getInputHeight } from "src/utils/formUtils/getInputHeight";
import { handleValidNumber } from "src/utils/validations/numberInput";
// import { GrFormAdd } from "react-icons/gr";
// import { setIsOpenAddSubjectDialog } from "src/redux/slices/SubjectSlice";
import { useDispatch, useSelector } from "react-redux";
// import AddSubjectWrapper from "src/screens/Subject/Add/AddSubjectWrapper";
// import { RootState } from "src/redux/store";
// import AddFacultyWrapper from "src/screens/Faculty/Add/AddFacultyWrapper";
// import { setIsOpenAddDialog as setIsOpenAddFacultyDialog } from "src/redux/slices/FacultySlice";
// import useFranchise from "src/hooks/useFrachise";
import { useGetAdvancePaymentMutation } from "src/services/OfflineOrderService";
import {
  handleValidDecimalNumber,
  handleValidNumber2,
} from "src/utils/formUtils/ValidNumber";
import { showToast } from "src/utils/showToaster";
import useProduct from "src/hooks/useProduct";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import PaymentModel from "../PaymentModel/PaymentModel";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import moment from "moment";
// import { PiNumberEightThin } from "react-icons/pi";

type Props = {
  formikProps: FormikProps<OfflineOrderFormValues>;
  onlineMode: any;
  physicalModes?: any[];
};
export const regIndiaPhone = RegExp(/^[0]?[6789]\d{9}$/);

const getProductLabel = (item: any) =>
  item?.productName || item?.title || "";

const getProductPrice = (item: any, variant?: any) =>
  Number(variant?.price ?? item?.productSellingPrice ?? item?.productMrp ?? 0);

const isSellableProduct = (item: any) =>
  Boolean(item) &&
  item?.isDeleted !== true &&
  item?.isHidden !== true &&
  item?.isActive !== false &&
  item?.isAvailable !== false;

const OPTION_FIELDS = [
  { key: "modeName", label: "Mode" },
  { key: "validity", label: "Validity" },
  { key: "noOfViews", label: "Views" },
  { key: "attempts", label: "Attempts" },
  { key: "language", label: "Language" },
  { key: "varientCode", label: "Variant" },
] as const;

const productGroupKey = (item: any) =>
  String(item?.productUrlSlug || "").trim();

const fieldValue = (item: any, key: string) => {
  const raw = item?.[key];
  if (raw === undefined || raw === null) return "";
  return String(raw).trim();
};

const selectionValue = (selected: any) => {
  if (!selected) return "";
  if (typeof selected === "string") return selected;
  return selected.value || "";
};

const toOption = (value: string) => ({
  label: value.toUpperCase(),
  value,
});

const uniqueFieldValues = (items: any[], key: string) => {
  const seen = new Set<string>();
  const values: string[] = [];
  items.forEach((item) => {
    const value = fieldValue(item, key);
    if (!value || seen.has(value)) return;
    seen.add(value);
    values.push(value);
  });
  return values;
};

const matchesFilters = (item: any, filters: Record<string, any>) =>
  OPTION_FIELDS.every((field) => {
    const selected = selectionValue(filters[field.key]);
    if (!selected) return true;
    return fieldValue(item, field.key) === selected;
  });

const syncSelections = (
  products: any[],
  current: Record<string, any>,
  changedKey?: string
) => {
  const next = { ...current };
  const changedValue = changedKey ? selectionValue(next[changedKey]) : "";
  if (changedKey && changedValue) {
    const anchored = products.filter(
      (item) => fieldValue(item, changedKey) === changedValue
    );
    OPTION_FIELDS.forEach((field) => {
      if (field.key === changedKey) return;
      const selected = selectionValue(next[field.key]);
      if (!selected) return;
      if (!uniqueFieldValues(anchored, field.key).includes(selected)) {
        next[field.key] = "";
      }
    });
  }

  for (let guard = 0; guard < OPTION_FIELDS.length; guard += 1) {
    const pool = products.filter((item) => matchesFilters(item, next));
    let changed = false;
    OPTION_FIELDS.forEach((field) => {
      if (field.key === changedKey && changedValue) return;
      const selected = selectionValue(next[field.key]);
      const values = uniqueFieldValues(pool, field.key);
      const shared =
        values.length === 1 &&
        pool.length > 0 &&
        pool.every((item) => fieldValue(item, field.key) === values[0]);
      if (shared) {
        if (selected !== values[0]) {
          next[field.key] = toOption(values[0]);
          changed = true;
        }
      } else if (selected && !values.includes(selected)) {
        next[field.key] = "";
        changed = true;
      }
    });
    if (!changed) break;
  }
  return {
    selections: next,
    matches: products.filter((item) => matchesFilters(item, next)),
  };
};

const getFieldOptions = (products: any[], key: string) =>
  uniqueFieldValues(products, key).map(toOption);

const describeVariant = (item: any) =>
  ["modeName", "noOfViews", "validity", "language", "varientCode"]
    .map((key) => fieldValue(item, key))
    .filter(Boolean)
    .join(" · ") || "-";

const OfflineOrderForm = ({
  formikProps,
  onlineMode,
  physicalModes = [],
}: Props) => {
  const {
    values,
    setFieldValue,
    isSubmitting,
    handleBlur,
    validateForm,
    setTouched,
    touched,
    submitForm,
    submitCount,
    errors,
    status,
  } = formikProps;
  const [advancedAmount, setAdvancedAmount] = useState(0);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [activeStep, setActiveStep] = useState(0);
  const [productError, setProductError] = useState("");
  const formTopRef = useRef<HTMLDivElement>(null);
  const [remainingFees, setRemainingFees] = useState<string>("");
  const listTotal = selectedItems.reduce(
    (acc, listedItem) =>
      acc + Number(listedItem.price || 0) * Number(listedItem.quantity || 0),
    0
  );

  useEffect(() => {
    setFieldValue("orderTotal", listTotal);
  }, [listTotal, setFieldValue]);

  useEffect(() => {
    if (!physicalModes?.length) return;
    const hasPhysicalNotes = (values.paymentMode || []).some(
      (mode: any) => mode?.type === "PHYSICAL"
    );
    if (hasPhysicalNotes) return;
    setFieldValue(
      "paymentMode",
      physicalModes.map((mode: any) => ({
        name: mode.name,
        value: mode.value,
        quantity: "",
        type: mode.type,
      }))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [physicalModes, setFieldValue]);
  const [getAvancePayments, advancePaymentInfo] =
    useGetAdvancePaymentMutation();
  useEffect(() => {
    if (!advancePaymentInfo?.isLoading && advancePaymentInfo?.data) {
      showToast(
        "success",
        `Rs. ${advancePaymentInfo?.data?.data} is available`
      );
      setAdvancedAmount(advancePaymentInfo?.data?.data);
      setFieldValue("totalAdvancePayment", advancePaymentInfo?.data?.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancePaymentInfo.isLoading]);

  const { product, isDataLoading } = useProduct();
  const [mobileForAdv, setMobileForAdv] = useState("");

  const [settleAdvancePayment, setSettleAdvancePayment] =
    useState<boolean>(false);
  useEffect(() => {
    const totalAmount = listTotal;
    const advancePayment = values.totalAdvancePayment;
    const receivedAmount = values.receivedAmt;
    const courierCharges = values.courierCharges;

    let discountAmount = 0;
    if (values.discountType?.value === "FLAT") {
      discountAmount = values.discount || 0;
    } else if (values.discountType?.value === "PERCENTAGE") {
      discountAmount = (Number(totalAmount) * Number(values.discount)) / 100;
    }

    const afterDiscount = Number(
      (
        Number(totalAmount) +
        Number(courierCharges || 0) -
        Number(discountAmount || 0)
      ).toFixed(2)
    );
    const afterCash = afterDiscount - Number(receivedAmount || 0);
    const advanceUsed = Math.min(
      Number(advancePayment || 0),
      Math.max(afterCash, 0)
    );
    const settleAmount = Number((afterCash - advanceUsed).toFixed(2));
    const remaining = Math.abs(settleAmount) < 0.005 ? 0 : settleAmount;
    setRemainingFees(String(remaining));
    setFieldValue("remainingFees", remaining);
  }, [
    listTotal,
    values.totalAdvancePayment,
    values.discount,
    values.courierCharges,
    values.receivedAmt,
    values.discountType,
    setFieldValue,
  ]);

  useEffect(() => {
    const orderTotal = values?.paymentMode.reduce(
      (total: any, payment: any) => {
        // Convert the 'amount' property to a number before summing
        return total + Number(payment.amount);
      },
      0
    );
    setFieldValue("amountPaid", Number(orderTotal) || 0);
    const calculateorderTotal = orderTotal - Number(values?.advanceAmount);
  }, [values?.totalFees, values?.receivedAmt]);

  useEffect(() => {
    let amountPaid = Number(values?.totalFees) - Number(values?.advanceAmount);
    setFieldValue("receivedAmt", amountPaid || 0);
  }, [values?.totalFees, values?.advanceAmount, values?.orderTotal]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sellableProducts = (product || []).filter(isSellableProduct);

  const ProductTypeOptions = (() => {
    const seen = new Set<string>();
    return sellableProducts
      .filter((item: any) => {
        const key = productGroupKey(item);
        if (!key || seen.has(key) || !getProductLabel(item)) return false;
        seen.add(key);
        return true;
      })
      .map((item: any) => ({
        label: getProductLabel(item),
        value: productGroupKey(item),
      }));
  })();

  const getProductsForSlug = (slug?: string) => {
    if (!slug) return [];
    return sellableProducts.filter((item: any) => productGroupKey(item) === slug);
  };

  const resolveProduct = (item: any) => {
    const matches = getProductsForSlug(item?.productId?.value).filter(
      (catalogProduct: any) => matchesFilters(catalogProduct, item)
    );
    return matches.length === 1 ? matches[0] : null;
  };

  const handleAdd = (index: number) => {
    const item = values.products[index];
    const catalogProduct = resolveProduct(item);

    if (!catalogProduct || !(item.quantity > 0)) {
      return;
    }

    const price = getProductPrice(catalogProduct);
    const books =
      catalogProduct.books?.map((book: any) => ({
        _id: book?.bookId,
        title: book?.bookName,
        isIssued: false,
      })) || [];

    const newSelectedItem = {
      _id: Date.now(),
      product: getProductLabel(catalogProduct),
      productId: catalogProduct._id,
      variantId: catalogProduct._id,
      variant: describeVariant(catalogProduct),
      price,
      quantity: item.quantity,
      books,
    };

    setSelectedItems((prev) => [...prev, newSelectedItem]);
    setProductError("");

    const initialBookIssued =
      catalogProduct.books?.map((book: any) => ({
        bookId: book?.bookId,
        isIssued: false,
      })) || [];

    setFieldValue("bookIssued", [
      ...values.bookIssued,
      {
        productId: newSelectedItem.productId,
        variantId: newSelectedItem.variantId,
        quantity: newSelectedItem.quantity,
        price: newSelectedItem.price,
        bookIssued: initialBookIssued,
      },
    ]);

    setFieldValue(`products[${index}]`, {
      productId: "",
      variantId: "",
      quantity: "",
    });
  };

  const handleDeleteProduct = (id: number) => {
    // Find the item being deleted
    const itemToDelete = selectedItems.find((item) => item._id === id);

    setSelectedItems((prev) => prev.filter((item) => item._id !== id));

    // Remove corresponding entry from bookIssued
    if (itemToDelete) {
      setFieldValue(
        "bookIssued",
        values.bookIssued.filter(
          (bi) =>
            !(
              bi.productId === itemToDelete.productId &&
              bi.variantId === itemToDelete.variantId
            )
        )
      );
    }
  };

  const columns: columnTypes[] = [
    { field: "product", headerName: "Product", flex: "flex-[1.5_1.5_0%]" },
    { field: "variant", headerName: "Variant", flex: "flex-[1.5_1.5_0%]" },
    {
      field: "price",
      headerName: "Price",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <div>₹{row?.price ?? 0}</div>,
    },
    { field: "quantity", headerName: "Quantity", flex: "flex-[1_1_0%]" },
    {
      field: "action",
      headerName: "Actions",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => (
        <ATMMenu
          options={[
            {
              label: "Delete",
              onClick: () => handleDeleteProduct(row._id),
            },
          ]}
        />
      ),
    },
  ];
  const DiscountTypeOptions = [
    { label: "None", value: "NONE" },
    {
      label: "Flat",
      value: "FLAT",
    },
    {
      label: "Percent (%)",
      value: "PERCENTAGE",
    },
  ];
  const DeliveryOptions = [
    {
      label: "PICKUP",
      value: "PICKUP",
    },
    {
      label: "HOME DELIVERY",
      value: "HOME_DELIVERY",
    },
  ];
  const userStepFields = [
    "name",
    "email",
    "mobile",
    "croNumber",
    "deliveryOption",
    "address",
    "city",
    "state",
    "pincode",
  ];

  const stepForField = (key: string) => {
    if (key === "bookIssued" || key.startsWith("products")) return 0;
    if (userStepFields.includes(key)) return 1;
    return 2;
  };

  const goToFirstError = (formErrors: Record<string, unknown>) => {
    const keys = Object.keys(formErrors || {});
    let step: number | null = selectedItems.length ? null : 0;
    keys.forEach((key) => {
      const fieldStep = stepForField(key);
      step = step === null ? fieldStep : Math.min(step, fieldStep);
    });
    if (step === null) {
      setProductError("");
      return false;
    }
    if (!selectedItems.length) {
      setProductError("Please add at least one product");
    }
    setActiveStep(step);
    return true;
  };

  useEffect(() => {
    formTopRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [activeStep]);

  useEffect(() => {
    if (!submitCount) return;
    if (!selectedItems.length || Object.keys(errors || {}).length) {
      goToFirstError(errors || {});
    }
    // Only react to a new submit attempt.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitCount]);

  useEffect(() => {
    if (status?.step === 0 || status?.step === 1 || status?.step === 2) {
      setActiveStep(status.step);
    }
  }, [status]);

  const handleNext = async () => {
    if (activeStep === 0) {
      if (!selectedItems.length) {
        setProductError("Please add at least one product");
        return;
      }
      setProductError("");
      setActiveStep(1);
      return;
    }

    if (activeStep === 1) {
      const formErrors = (await validateForm()) as Record<string, unknown>;
      const userErrors = userStepFields.filter((field) => formErrors[field]);
      if (userErrors.length) {
        setTouched(
          {
            ...touched,
            ...Object.fromEntries(userErrors.map((field) => [field, true])),
          },
          false
        );
        return;
      }
      setActiveStep(2);
    }
  };

  const handleSave = async () => {
    const formErrors = (await validateForm()) as Record<string, unknown>;
    setTouched(
      {
        ...touched,
        ...Object.fromEntries(Object.keys(formErrors).map((key) => [key, true])),
      },
      false
    );
    if (!selectedItems.length || Object.keys(formErrors).length) {
      goToFirstError(formErrors);
      return;
    }
    submitForm();
  };

  const steps = [
    { label: "Product Details" },
    { label: "User Details" },
    { label: "Payment Details" },
  ];

  return (
    <>
      <div className="p-4" ref={formTopRef}>
        <div className="mb-6 rounded-xl border border-primary-main/10 bg-white p-4 shadow-sm">
          <div className="flex items-center">
            {steps.map((step, index) => {
              const isActive = index === activeStep;
              const isDone = index < activeStep;
              return (
                <React.Fragment key={step.label}>
                  <button
                    type="button"
                    onClick={() => {
                      if (index < activeStep) setActiveStep(index);
                    }}
                    className={`flex items-center gap-2 ${
                      index < activeStep ? "cursor-pointer" : "cursor-default"
                    }`}
                  >
                    <span
                      className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold ${
                        isActive
                          ? "bg-primary-main text-white"
                          : isDone
                          ? "bg-accent text-primary-main"
                          : "bg-surface-medium text-slate-500"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span
                      className={`text-sm font-semibold ${
                        isActive || isDone
                          ? "text-primary-main"
                          : "text-slate-400"
                      }`}
                    >
                      {step.label}
                    </span>
                  </button>
                  {index < steps.length - 1 && (
                    <div
                      className={`mx-3 h-[3px] flex-1 rounded ${
                        index < activeStep ? "bg-accent" : "bg-slate-200"
                      }`}
                    />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
        {activeStep === 1 && (
        <>
        <p className="border-l-4 p-2 border-accent font-bold text-xl text-primary-main">
          User Details
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 my-6">
          <div>
            <ATMTextField
              name="name"
              value={values?.name}
              required
              onChange={(e) => {
                setFieldValue("name", e.target.value);
              }}
              label="Name"
              onBlur={handleBlur}
              placeholder="Please enter name"
            />
          </div>
          <div>
            <ATMTextField
              name="email"
              value={values?.email}
              required
              onChange={(e) => {
                setFieldValue("email", e.target.value);
              }}
              label="Email"
              placeholder="Please enter email"
              // onBlur={handleBlur}
            />
          </div>
          <div>
            <ATMTextField
              name="mobile"
              value={values?.mobile}
              maxLength={10}
              required
              onChange={(e) => {
                handleValidNumber2(e) &&
                  setFieldValue("mobile", e.target.value);
              }}
              label="Mobile"
              onBlur={handleBlur}
              placeholder="Please enter number"
            />
          </div>
          <div>
            <ATMTextField
              name="croNumber"
              value={values?.croNumber}
              onChange={(e) => {
                setFieldValue("croNumber", e.target.value);
              }}
              label="CRO Number"
              onBlur={handleBlur}
              placeholder="Please enter CRO number"
            />
          </div>
        </div>
        </>
        )}
        {activeStep === 0 && (
        <>
        <p className="border-l-4 p-2 border-accent font-bold text-xl text-primary-main">
          Product Details
        </p>
        <FieldArray name="products">
          {({ push, remove }) => (
            <div>
              {values.products?.map((item, index) => {
                const slugProducts = getProductsForSlug(item?.productId?.value);
                const resolvedProduct = resolveProduct(item);
                const visibleFields = OPTION_FIELDS.filter(
                  (field) => uniqueFieldValues(slugProducts, field.key).length > 0
                );

                return (
                  <div
                    key={index}
                    className="grid grid-cols-1 md:grid-cols-2 gap-4 my-6"
                  >
                    <div className="md:col-span-2">
                      <ATMSelect
                        name={`products[${index}].productId`}
                        label="Product"
                        placeholder="Select Product"
                        isLoading={isDataLoading}
                        options={ProductTypeOptions}
                        value={item.productId}
                        onChange={(newValue: any) => {
                          const nextProducts = getProductsForSlug(newValue?.value);
                          const { selections } = syncSelections(nextProducts, {
                            productId: newValue,
                            variantId: "",
                            quantity: item.quantity || "",
                          });
                          const nextRows = values.products.map(
                            (row, rowIndex) =>
                              rowIndex === index ? selections : row
                          );
                          setFieldValue("products", nextRows);
                        }}
                      />
                    </div>

                    {visibleFields.map((field) => {
                      const options = getFieldOptions(slugProducts, field.key);
                      return (
                        <ATMSelect
                          key={field.key}
                          name={`products[${index}].${field.key}`}
                          label={field.label}
                          placeholder={`Select ${field.label}`}
                          options={options}
                          value={item[field.key] || ""}
                          onChange={(newValue: any) => {
                            const { selections } = syncSelections(
                              slugProducts,
                              {
                                ...item,
                                [field.key]: newValue || "",
                              },
                              field.key
                            );
                            const nextRows = values.products.map(
                              (row, rowIndex) =>
                                rowIndex === index ? selections : row
                            );
                            setFieldValue("products", nextRows);
                          }}
                          disabled={!item.productId || options.length <= 1}
                        />
                      );
                    })}

                    <ATMTextField
                      name={`products[${index}].quantity`}
                      label="Quantity"
                      value={item.quantity || ""}
                      onChange={(e: any) =>
                        setFieldValue(
                          `products[${index}].quantity`,
                          Number(e.target.value)
                        )
                      }
                      placeholder="Enter Quantity"
                      type="number"
                    />

                    <ATMLoadingButton
                      type="button"
                      className="mt-6"
                      onClick={() => handleAdd(index)}
                      disabled={
                        !resolvedProduct || !(Number(item.quantity) > 0)
                      }
                    >
                      Add to List
                    </ATMLoadingButton>
                    {item.productId && !resolvedProduct ? (
                      <p className="md:col-span-2 text-sm text-slate-500">
                        Select the remaining options to choose this product.
                      </p>
                    ) : null}
                  </div>
                );
              })}
            </div>
          )}
        </FieldArray>
        <ATMTable columns={columns} rows={selectedItems} />
        {/* Total Price */}
        <div className="text-right mt-4 font-bold text-lg text-primary-main">
          Total Price: ₹{listTotal}
        </div>
        {productError ? (
          <p className="mt-2 text-sm font-medium text-red-500">{productError}</p>
        ) : null}
        </>
        )}
        {activeStep === 1 && (
        <>
        <p className="border-l-4 p-2 mt-5 border-accent font-bold text-xl text-primary-main">
          Delivery
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-6">
          <div>
            <ATMSelect
              name="deliveryOption"
              required
              placeholder="Delivery Option"
              label="Delivery Option"
              options={DeliveryOptions}
              onChange={(newValue: any) => {
                setFieldValue("deliveryOption", newValue);
              }}
              value={values?.deliveryOption}
            />
          </div>
          {values?.deliveryOption?.value === "HOME_DELIVERY" ? (
            <>
              <div>
                <ATMTextField
                  name="city"
                  value={values?.city}
                  onChange={(e) => {
                    setFieldValue("city", e.target.value);
                  }}
                  label="City"
                  placeholder="Please enter city"
                />
              </div>
              <div>
                <ATMTextField
                  name="state"
                  value={values?.state}
                  onChange={(e) => {
                    setFieldValue("state", e.target.value);
                  }}
                  label="State"
                  placeholder="Please enter state"
                />
              </div>
              <div>
                <ATMTextField
                  name="pincode"
                  value={values?.pincode}
                  onChange={(e) => {
                    setFieldValue("pincode", e.target.value);
                  }}
                  label="Pincode"
                  placeholder="Please enter pincode"
                />
              </div>
              <div>
                <ATMTextField
                  name="courierCharges"
                  value={values?.courierCharges}
                  onChange={(e) => {
                    handleValidDecimalNumber(e) &&
                      setFieldValue("courierCharges", e.target.value);
                  }}
                  label="Courier charges"
                  placeholder="Please enter courier charges"
                />
              </div>
            </>
          ) : null}
        </div>
        {values?.deliveryOption?.value === "HOME_DELIVERY" ? (
          <>
            <div>
              <ATMTextArea
                name="address"
                value={values?.address}
                onChange={(e) => {
                  setFieldValue("address", e);
                }}
                label="Address"
                placeholder="Please enter address"
              />
            </div>
          </>
        ) : null}
        </>
        )}
        {activeStep === 2 && (
        <>
        <div>
          <p className="border-l-4 p-2 mt-5 border-accent font-bold text-xl text-primary-main">
            Discount
          </p>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
            <div className="">
              <ATMSelect
                name="discountType"
                required
                placeholder="Select discount Option"
                label="Discount Type"
                options={DiscountTypeOptions}
                onChange={(newValue: any) => {
                  setFieldValue("discountType", newValue);
                }}
                value={values?.discountType}
              />
            </div>
            <div>
              <ATMTextField
                name="discount"
                value={values.discount}
                onChange={(e) =>
                  handleValidDecimalNumber(e) &&
                  setFieldValue("discount", e.target.value)
                }
                label="Discount Amount"
                placeholder="Enter Discount Amount"
                onBlur={handleBlur}
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 my-5">
          <p className="border-l-4 p-2 mt-5 border-accent font-bold text-xl text-primary-main">
            Payment Details
          </p>
          <p
            className=" text-md text-secondary-main underline my-4 font-bold cursor-pointer"
            onClick={() => setSettleAdvancePayment(true)}
          >
            Settle Advance Payment
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4  my-6">
          {settleAdvancePayment ? (
            <>
              <div>
                <div className="flex gap-2 items-center">
                  <ATMTextField
                    placeholder="Please enter Mobile Number"
                    name="mobileForAdv"
                    value={mobileForAdv}
                    onChange={(e) => {
                      handleValidNumber(e) && setMobileForAdv(e.target.value);
                    }}
                    label="Search Advance Payment"
                    onBlur={handleBlur}
                  />
                  <div className="mt-5">
                    <ATMLoadingButton
                      className="w-fit "
                      disabled={!mobileForAdv.match(regIndiaPhone)}
                      onClick={() => {
                        getAvancePayments({
                          mobile: mobileForAdv,
                        });
                        setFieldValue(`adjustAgainstMobile`, mobileForAdv);
                      }}
                      isLoading={advancePaymentInfo?.isLoading}
                    >
                      Search
                    </ATMLoadingButton>
                  </div>
                </div>
                <span>
                  <span className="text-sm font-medium">
                    Total Advance Amount
                  </span>{" "}
                  : &#8377;{advancedAmount || 0}
                </span>
              </div>
            </>
          ) : null}
        </div>
        <span className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <ATMTextField
              name="receivedAmt"
              value={values?.receivedAmt}
              onChange={(e) =>
                handleValidDecimalNumber(e) &&
                setFieldValue("receivedAmt", e.target.value)
              }
              label="received Amount"
              placeholder="Enter received Amount"
              onBlur={handleBlur}
            />
          </div>
          <div>
            <ATMTextField
              name="remainingFees"
              value={remainingFees}
              onChange={(e) => {
                setFieldValue("remainingFees", e.target.value);
              }}
              label="Remaning fees"
              onBlur={handleBlur}
              disabled
            />
          </div>
          <ATMDatePicker
            label="Due Date "
            name="duedate"
            required={Number(values.remainingFees) > 0}
            format="DD/MM/YYYY"
            minDate={moment().format("YYYY-MM-DD")}
            value={values.duedate || null}
            onChange={(newValue) => {
              if (!newValue || !moment(newValue).isValid()) {
                setFieldValue("duedate", "");
                return;
              }
              setFieldValue("duedate", moment(newValue).format("YYYY-MM-DD"));
            }}
          />
        </span>
        <div>
          <PaymentModel formikProps={formikProps} onlineMode={onlineMode} />
        </div>
        <div className="mt-5">
          <ATMTextArea
            name="remark"
            value={values?.remark}
            onChange={(e) => {
              setFieldValue("remark", e);
            }}
            label="Remark"
            placeholder="Please enter remark"
          />
        </div>
        </>
        )}
      </div>

      <div className="flex justify-end mt-2 px-3 gap-2 pb-4">
        <ATMLoadingButton
          className="w-24 bg-white font-medium text-primary-main border border-primary-main"
          type="button"
          onClick={() => navigate("/offline-order")}
        >
          Cancel
        </ATMLoadingButton>
        {activeStep > 0 && (
          <ATMLoadingButton
            className="w-24 bg-white font-medium text-primary-main border border-primary-main"
            type="button"
            onClick={() => setActiveStep((step) => step - 1)}
          >
            Back
          </ATMLoadingButton>
        )}
        {activeStep < 2 ? (
          <ATMLoadingButton className="w-24" type="button" onClick={handleNext}>
            Next
          </ATMLoadingButton>
        ) : (
          <ATMLoadingButton
            className="w-24"
            isLoading={isSubmitting}
            type="button"
            onClick={handleSave}
          >
            Save
          </ATMLoadingButton>
        )}
      </div>
    </>
  );
};

export default OfflineOrderForm;
